module.exports = __webpack_public_path__ + "media/images/flags/lt-bf71f70dcd96ac579b0f5edc374481e3.svg";